export const LOGIN_ADMIN_IMAGE = "LoginAdminImage";
export const LOGIN_FORM_ID = "LoginFormId";
export const LOGIN_FORM_EMAIL = "LoginFormEmail";
export const LOGIN_FORM_PASSWORD = "LoginFormPassword";
export const LOGIN_FORM_SIGN_IN_BUTTON = "LoginFormSignInButton";
export const LOGIN_IN_PROGRESS_ID = "LoginInProgress";
